import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import { clickMainNavigationGA } from "../../analytics";
import { WithBannerData } from "../../HOC/WithHeaderData";
import { BookNowButton } from "../Common/BookNowButton";
import { HeaderBanner } from "./HeaderBanner";

function Header() {
  const { pathname, search } = useLocation();
  const [expandNav, setExpandNav] = useState(false);

  useEffect(() => {
    if (typeof window.ga === "function") {
      window.ga("set", "page", pathname + search);
      window.ga("send", "pageview");
    }
  }, [pathname, search]);

  const isParksPage = pathname.startsWith("/parks");

  const handleNavClick = (page) => {
    if (expandNav) {
      setExpandNav(false);
    }
    clickMainNavigationGA(page);
  };

  return (
    <>
      <WithBannerData>
        <HeaderBanner />
      </WithBannerData>
      <Navbar
        expand="lg"
        expanded={expandNav}
        bg="dark"
        variant="dark"
        sticky={isParksPage ? undefined : "top"}
        className="p-0"
      >
        <Container className="p-0 pr-3">
          <Navbar.Brand>
            <Link to="/">
              <span className="club-logo">Club 950</span>
            </Link>
          </Navbar.Brand>
          <div className="d-flex flex-row align-items-center">
            <BookNowButton className="d-block d-lg-none" parent="Header" />
            <Navbar.Toggle aria-controls="responsive-navbar" id="nav-toggle" onClick={() => setExpandNav(!expandNav)}>
              <span />
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse id="responsive-navbar">
            <Nav className="ml-auto p-3 p-lg-0">
              <NavLink
                className="nav-link mr-3 p-0"
                to="/"
                onClick={() => handleNavClick("home")}
                exact
                data-testid="navbar-home"
              >
                <span className="icon-font size-175 font-weight-normal line-height-fix">@</span>
              </NavLink>
              <NavLink
                className="nav-link mr-3"
                to="/parks"
                onClick={() => handleNavClick("parks")}
                data-testid="navbar-parks"
              >
                Browse Parks
              </NavLink>
              <NavLink
                className="nav-link mr-3"
                to="/how-it-works"
                onClick={() => handleNavClick("hiw")}
                data-testid="navbar-hiw"
              >
                How it Works
              </NavLink>
              <NavLink
                className="nav-link mr-3"
                to="/faq"
                onClick={() => handleNavClick("faq")}
                data-testid="navbar-faq"
              >
                FAQs
              </NavLink>
              <NavLink
                className="nav-link mr-3"
                to="/ferries"
                onClick={() => handleNavClick("ferries")}
                data-testid="navbar-ferries"
              >
                Ferries
              </NavLink>
              <BookNowButton className="mt-4 mt-lg-0 d-none d-lg-block" parent="Header" />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
